import {ShowHide} from './Helpers'

let obj = {
    message:"Loading..."
};

obj = Object.assign(new ShowHide(false),obj);

export default obj;